var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZhaoshangju(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755534374348,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 15958,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M386.133333 414.037333l-97.493333 238.506667h387.584L578.901333 413.013333l-96.469333 236.373334-96.256-235.349334z m379.52 181.418667h77.397334a346.325333 346.325333 0 0 1-4.821334 17.28h-65.664l-6.912-17.28z m-13.013333-32.469333h96.896c-0.853333 5.802667-1.877333 11.52-3.029333 17.237333h-86.954667l-6.912-17.237333z m-13.056-32.469334h113.237333c-0.298667 5.76-0.768 11.52-1.322666 17.237334h-104.96l-6.954667-17.237334z m-13.013333-32.512h126.464c0.213333 4.650667 0.298667 9.301333 0.298666 13.994667v3.285333H733.44l-6.912-17.28z m-13.013334-32.426666h136.661334c0.768 5.674667 1.408 11.434667 1.877333 17.237333h-131.626667l-6.912-17.28z m-13.013333-32.512h143.616c1.365333 5.717333 2.56 11.477333 3.626667 17.28H707.413333l-6.912-17.28zM170.666667 512a341.333333 341.333333 0 0 1 669.525333-94.165333h-145.749333l-85.034667-212.053334-95.402667 237.226667-97.322666-235.093333-180.352 444.586666 73.6 103.637334h407.296l70.442666-105.728-9.002666-22.485334h54.485333A341.333333 341.333333 0 0 1 170.666667 512z",
    "p-id": 15959
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhaoshangju);
export default __webpack_public_path__ + "static/media/zhaoshangju.b095b01b2663916cfcfb794c471e68b4.svg";
export { ForwardRef as ReactComponent };